import { render, staticRenderFns } from "./TheUploadLogo.vue?vue&type=template&id=767a4b86&scoped=true"
import script from "./TheUploadLogo.vue?vue&type=script&lang=js"
export * from "./TheUploadLogo.vue?vue&type=script&lang=js"
import style0 from "./TheUploadLogo.vue?vue&type=style&index=0&id=767a4b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a4b86",
  null
  
)

export default component.exports